import * as React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '@goparrot-dashboard/i18n';

export const SignInLink: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { getIntlString } = useI18n();

  return (
    <Link to="/auth/sign-in" className="tw-font-medium tw-text-light-blue-600 hover:tw-text-light-blue-500" data-testid="sign-in-already-have-account-link">
      {getIntlString('link.signIn')}
    </Link>
  );
};
